import {Props} from './model';
import {ResponsiveView} from '../../../shared/components/responsiveView';
import {DeviceSize, useDeviceSize} from '../../../shared/theme/helpers';
import {View, Text} from 'react-native';
import {Hr} from '../../../shared/components/hr';
import {ContactsCard} from '../../../shared/components/contactsCard';
import {images} from '../../../assets/icons';
import {formatPhone, formatUrl, openExternalLink, openExternalPhone} from '../../../shared/pipes';
import {Transport} from '../../../assets/images';
import React from 'react';
import {useStyles} from '../../../shared/hooks/styles';
import {Button} from '../../../shared/components/button';
import {Markdown} from '../../../shared/components/markdown';
import {ContentWithRightImage} from '../../../shared/components/contentWithRightImage';
import {Image} from '../../../shared/components/image';

export default ({content}: Props) => {
  const deviceSize = useDeviceSize();
  const styles = useStyles(({theme, mediaOnly}) => {
    return {
      sectionWithImageContainer: {
        ...mediaOnly(DeviceSize.desktop, {marginBottom: theme.screen.bottomOffset}, {paddingBottom: 60}),
      },
      sectionWithImageBg: mediaOnly(
        DeviceSize.desktop,
        {
          top: -93,
        },
        {
          right: -24,
          bottom: -74,
        },
      ),
      sectionWithImageIcon: mediaOnly(DeviceSize.desktop, {
        top: -93,
        left: -35,
      }),
      featuresTitle: {
        marginBottom: 18,
      },
      featuresTitleText: {
        ...mediaOnly(
          DeviceSize.desktop,
          {
            ...theme.fonts.h3Light,
            marginBottom: 22,
          },
          {
            ...theme.fonts.action,
            marginBottom: 20,
          },
        ),
        color: theme.color.textColor,
      },
      contentTextWrapper: mediaOnly(DeviceSize.desktop, {marginBottom: 0}, {marginBottom: 30}),
      contacts: {
        marginBottom: 20,
      },
      openBankButton: mediaOnly(DeviceSize.desktop, {width: 557}),
    };
  });

  const getWidthByDesktopAndBank = (isPochta: boolean, _deviceSize: DeviceSize) => {
    if (isPochta) {
      if (_deviceSize !== DeviceSize.desktop) {
        return 100;
      }
      return undefined;
    }
    return _deviceSize === DeviceSize.desktop ? 318 : 290;
  };
  return (
    <ContentWithRightImage
      containerStyle={styles.sectionWithImageContainer}
      backgroundStyle={styles.sectionWithImageBg}
      iconStyle={styles.sectionWithImageIcon}
      icon={<Image source={Transport as any} width={440} height={400} />}>
      <View style={styles.contentTextWrapper}>
        <ResponsiveView only={[DeviceSize.desktop]}>
          <Text testID='financial-desktop-transport-card-description-id' style={styles.featuresTitleText}>
            {content.services.transportService.financial.descriptionDesktop}
          </Text>
        </ResponsiveView>
        <ResponsiveView exclude={[DeviceSize.desktop]}>
          <Text testID='financial-mobile-transport-card-description-id' style={styles.featuresTitleText}>
            {content.services.transportService.financial.descriptionMobile}
          </Text>
        </ResponsiveView>
        <Markdown listColumns={1}>{content.services.transportService.financial.featureListMarkdown}</Markdown>
      </View>
      <Hr marginBottom={30} marginTop={deviceSize === DeviceSize.desktop ? 30 : 0} />
      <View style={styles.contacts}>
        <ContactsCard
          contacts={[
            {
              icon: images.Phone,
              value: formatPhone(content.services.bankingService.bankPhone),
              onPress: () => openExternalPhone(content.services.bankingService.bankPhone),
            },
            {
              icon: images.Globe,
              value: formatUrl(content.services.bankingService.bankWebsite),
              onPress: () => {
                openExternalLink(content.services.bankingService.bankWebsite);
              },
            },
          ]}
          imageProps={{
            source: {uri: content.services.bankingService.logoUrl},
            width: getWidthByDesktopAndBank(
              content.services.bankingService.bankWebsite?.includes('pochta') || false,
              deviceSize,
            ),
            height: deviceSize === DeviceSize.desktop ? 100 : 47,
          }}
        />
      </View>
      {content.services.bankingService.bankEntryLink ? (
        <View style={styles.openBankButton}>
          <Button
            id='bank-lk'
            onPress={() => openExternalLink(content.services.bankingService.bankEntryLink)}
            block={true}
            type='secondary'
            text='Войти в личный кабинет банка'
          />
        </View>
      ) : null}
    </ContentWithRightImage>
  );
};
